module.exports = __webpack_public_path__ + "img/CA.126d37bb.png";